/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const newPhraseKioskLoaderScreenSchema = z.object({
	kiosk_loader_screen_phrase_for_created: z.array(z.any()),
	kiosk_loader_screen_phrase_for_fiscalized: z.array(z.any()),
	kiosk_loader_screen_phrase_for_completed: z.array(z.any()),
});
